import { render, staticRenderFns } from "./TreatmentTimelineTabs.vue?vue&type=template&id=8bf4520a&scoped=true"
import script from "./TreatmentTimelineTabs.vue?vue&type=script&lang=js"
export * from "./TreatmentTimelineTabs.vue?vue&type=script&lang=js"
import style0 from "./TreatmentTimelineTabs.vue?vue&type=style&index=0&id=8bf4520a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf4520a",
  null
  
)

export default component.exports